import { FormattedMessage } from 'react-intl';

import { CopyTextIcon } from '@shieldpay/bumblebee/copy-text-icon';
import { Heading } from '@shieldpay/bumblebee/heading';
import CopyTextIconMarkdown from '@shieldpay/bumblebee/markdown/copy-text-icon.md';
import { Text } from '@shieldpay/bumblebee/text';
import { TextList } from '@shieldpay/bumblebee/text-list';

import { ContentsTable } from '~/components/contents-table/contents-table';
import { Design } from '~/components/design/design';
import { MdxFormatter } from '~/components/mdx-formatter/mdx-formatter';
import { ComponentPreview } from '~/components/preview/component-preview';
import { createMeta } from '~/utilities/create-meta';

export const meta = createMeta({
  id: 'hive.components.copyTextIcon.title',
});

export const CopyTextIconPage = () => {
  return (
    <>
      <Heading>
        <FormattedMessage id="hive.components.copyTextIcon.title" />
      </Heading>

      <ContentsTable />

      <ComponentPreview alignContent={{ x: 'left' }}>
        <Heading level="3" variant="title">
          Default variant
        </Heading>
        <Text>
          This variant is designed to be used when it needs to be inline with
          text. Just{' '}
          <CopyTextIcon
            idleTooltipText="Click to copy"
            copiedTooltipText="Copied!"
          >
            click to copy this text
          </CopyTextIcon>{' '}
          and you will see the text copied to your clipboard.
        </Text>
        <Heading level="3" variant="title">
          Tag variant
        </Heading>
        <CopyTextIcon
          idleTooltipText="Click to copy"
          copiedTooltipText="Copied!"
          variant="tag"
        >
          Tag you are it!
        </CopyTextIcon>
      </ComponentPreview>

      <Design>
        <Design.Section heading="Usage">
          <Text paragraph>
            The copy text icon allows users to copy words or sentences and hold
            it in the clipboard. This helps the user to copy specific words
            without missing any characters.
          </Text>
        </Design.Section>
        <Design.Section heading="Placement">
          <Text paragraph>
            Current the copy icon is used in two places: Please refer to
            Placement in page designs for examples.
          </Text>

          <TextList>
            <TextList.Item>Balances card</TextList.Item>
            <TextList.Item>Settlement account page</TextList.Item>
            <Text paragraph>
              Please refer to Placement in page designs for examples.
            </Text>
          </TextList>
        </Design.Section>
        <Design.Section heading="Accessibility">
          <Text paragraph>
            Use the appropriate ARIA attributes for screen readers where
            applicable.
          </Text>
        </Design.Section>
        <Design.Section heading="Behaviour">
          <Text paragraph>Default, Before entry</Text>
          <Text paragraph>
            Text colour: Global/neutral-500
            <br />
            Icon colour: Global/neutral-300
          </Text>
          <Text paragraph>Hover, user mouses over </Text>
          <Text paragraph>
            Text colour: Global/neutral-500
            <br />
            Icon colour turns: Global/neutral-300
          </Text>
          <Text paragraph>Copied, user clicks on icon </Text>
          <Text paragraph>
            Text colour: Global/neutral-500
            <br />
            Icon colour turns: Global/success-500 Toast appears at the bottom of
            the screen
          </Text>
        </Design.Section>
      </Design>

      <MdxFormatter md={CopyTextIconMarkdown} />
    </>
  );
};

export default CopyTextIconPage;
